/**
 * If navigator is present.
 */
export function hasNavigator() {
    return typeof navigator !== 'undefined';
}
/**
 * If mediaDevices under navigator is supported.
 */
function isMediaDevicesSuported() {
    return hasNavigator() && !!navigator.mediaDevices;
}
/**
 * If enumerateDevices under navigator is supported.
 */
export function canEnumerateDevices() {
    return !!(isMediaDevicesSuported() && navigator.mediaDevices.enumerateDevices);
}
//# sourceMappingURL=navigator-utils.js.map